import Icon from "./Icon";

const Loading = ({
  size = "lg",
  className,
}: {
  size?: "lg" | "sm";
  className?: string;
}) => {
  return (
    <div
      className={`loader-wrap-wrap d-flex align-items-center justify-content-center ${className || ""}`}
    >
      <Icon className={`loader-wrap loader-wrap--${size}`} icon="loading" />
    </div>
  );
};

export default Loading;
